import { FileModel } from "../FileModel";

export interface GrupoDTO {
  iddecinvgrupoinvestigacion: number;
  iddecinvgrupoinvestigacionevento: number;
  nombre: string;
  idpersona: number;
  nombrePersona: string;
  objetivoGrupo: string;
  observacion: string;
  tipo: string;
  estado: string;
  activo: string;
  fecharegistro: Date;
}

export interface GrupoObjEspecificoDTO {
  iddecinvgrupoinvestigacion: number;
  objetivo: string;
  iddecinvgrupoobjespecifico: number;
}

export interface GrupoAlertas {
  tipo: string;
  mensaje: string;
}

export interface GrupoInvestigacionDTO {
  iddecinvgrupoinvestigacion: number;
  nombre: string;
  objetivogrupo?: string;
  grupoObjEspecificos: GrupoObjEspecificoDTO[];
}

// DTO de GrupoInvEvento
export interface GrupoInvEventoDTO {
  iddecinvgrupoinvestigacionevento: number;
  iddecinvgrupoinvestigacion: number;
  idpersona: number;
  observacion?: string;
  tipo?: string;
  estado?: string;
  activo?: string;
}

// DTO combinado
export interface GrupoCompletoDTO {
  datosGenerales: GrupoInvestigacionDTO;
  ultimoEventoGrupo: GrupoInvEventoDTO;
  miembrosEspol: Array<MiembroGrupoDTO>;
  miembrosExternos: Array<MiembroGrupoDTO>;
  lineasInv: Array<GrupoLineaInvestigacionDTO>;
}

export interface GrupoInvMiembroArchivo {
  iddecinvgrupoinvestigacionmiembroarchivo: number;
  iddecinvgrupoinvestigacionmiembro: number;
  idinstitucion: number;
  tipoarchivo: string;
  refarchivo: string;
}

export interface MiembroGrupoDTO {
  numeroidentificacion: string;
  iddecinvgrupoinvestigacionmiembro: number;
  iddecinvgrupoinvestigacion: number;
  idpersona: number;
  tipo: number;
  nombrecompleto: string;
  clasificacion: string;
  estado: string;
  idunidad: number;
  institucion: string;
  email: string;
  idcentro: number;
  scopusId: string;
  centroinvestigacion: string;
  contratosInfo: ContratoInfo[];
  archivos?: GrupoInvMiembroArchivo[];
  curriculum: FileModel | null,
  convenio: FileModel | null,
  formato: FileModel | null,
}

export interface GrupoLineaInvestigacionDTO {
  iddecinvgrupolineainvestigacion: number;
  iddecinvgrupoinvestigacion: number;
  iddecinvareaconocimiento: number;
  iddecinvlineasinvestigacion: number;
  nombreArea: string;
  nombreLinea: string;
}

export interface PersonaGrupo {
  idpersona: number;
  numeroidentificacion: string;
  nombrecompleto: string;
  email: string;
  scopusId: string;
}

export interface PersonaScopus {
  idpersona: number;
  scopusId: string;
}

export interface PostMiembroGrupoDTO {
  idcreador: number;
  miembro: MiembroGrupoDTO;
}

export interface AreaConocimiento {
  idDecInvAreaConocimiento: number,
  nombre: string
}

export interface ValidacionPersona {
  idpersona: number,
  esMaster: boolean,
  esEstudianteMaestria: boolean,
  nombreMaestria: string,
  esPhD: boolean,
  esEstudiantePhD: boolean,
  nombrePhD: string
}

export interface GrupoReasignacionDTO {
  Iddecinvgrupoinvestigacion: number;
  IdNuevoEncargado: number;
  InfoEncargado?: string;
  Observacion: string;
}

export interface GrupoCambioEstadoDTO {
  Iddecinvgrupoinvestigacion: number;
  IdPersona: number;
  Tipo: string;
  IdPersonaMiembro: number;
  Estado: string;
  Observacion: string;
}

export interface GrupoInvestigacionEventoDTO {
  iddecinvgrupoinvestigacionevento: number;
  iddecinvgrupoinvestigacion: number;
  idpersona: number;
  observacion: string;
  tipo: string;
  estado: string;
  activo: string;
  fecharegistro: Date;
}

export interface GrupoUsuario {
  idGrupo: number;
  nombreGrupo: string;
  estadoGrupo: string;
  coordinadorGrupo: string;
  rolUsuario: string;
  estadoUsuario: string;
  fechaFin?: Date; // solo cuando el usuario está INACTIVO
}

export interface ContratoInfo {
  numeroContrato?: string;
  cargo?: string;
  tiempoJornada?: string;
  nivelDocencia?: string;
  esDocente: boolean;
  esTiempoCompleto: boolean;
  esTitular: boolean;
}

export const voidGrupoDTO = (): GrupoDTO => ({
  iddecinvgrupoinvestigacion: 0,
  iddecinvgrupoinvestigacionevento: 0,
  nombre: '',
  idpersona: 0,
  nombrePersona: '',
  objetivoGrupo: '',
  observacion: '',
  tipo: '',
  estado: '',
  activo: '',
  fecharegistro: new Date(0),
});

export const voidGrupoInvestigacionDTO = (): GrupoInvestigacionDTO => ({
  iddecinvgrupoinvestigacion: 0,
  nombre: '',
  objetivogrupo: '',
  grupoObjEspecificos: []
});

export const voidGrupoInvEventoDTO = (): GrupoInvEventoDTO => ({
  iddecinvgrupoinvestigacionevento: 0,
  iddecinvgrupoinvestigacion: 0,
  idpersona: 0,
  observacion: '',
  tipo: '',
  estado: '',
  activo: '',
});

export const voidGrupoCompletoDTO = (): GrupoCompletoDTO => ({
  datosGenerales: voidGrupoInvestigacionDTO(),
  ultimoEventoGrupo: voidGrupoInvEventoDTO(),
  miembrosEspol: [],
  miembrosExternos: [],
  lineasInv: []
});

export const voidMiembroGrupoDTO = (): MiembroGrupoDTO => ({
  numeroidentificacion: '',
  iddecinvgrupoinvestigacionmiembro: 0,
  iddecinvgrupoinvestigacion: 0,
  idpersona: 0,
  tipo: 1,
  nombrecompleto: '',
  clasificacion: 'C',
  estado: 'P',
  idunidad: 0,
  institucion: '',
  email: '',
  scopusId: '',
  idcentro: 0,
  centroinvestigacion: '',
  contratosInfo: [],
  curriculum: null,
  formato: null,
  convenio: null,
});

export const voidMiembroGrupoDTO2 = (): MiembroGrupoDTO => ({
  numeroidentificacion: '',
  iddecinvgrupoinvestigacionmiembro: 0,
  iddecinvgrupoinvestigacion: 0,
  idpersona: 0,
  tipo: 2,
  nombrecompleto: '',
  clasificacion: 'C',
  estado: 'P',
  idunidad: 0,
  institucion: '',
  email: '',
  scopusId: '',
  idcentro: 0,
  centroinvestigacion: '',
  contratosInfo: [],
  curriculum: null,
  formato: null,
  convenio: null,
});

export function VoidGrupoInvMiembroArchivo(): GrupoInvMiembroArchivo {
  return {
    iddecinvgrupoinvestigacionmiembroarchivo: 0,
    iddecinvgrupoinvestigacionmiembro: 0,
    idinstitucion: 0,
    tipoarchivo: '',
    refarchivo: '',
  }
}

export const voidGrupoLineaInvestigacionDTO = (): GrupoLineaInvestigacionDTO => ({
  iddecinvgrupolineainvestigacion: 0,
  iddecinvgrupoinvestigacion: 0,
  iddecinvareaconocimiento: 0,
  iddecinvlineasinvestigacion: 0,
  nombreArea: '',
  nombreLinea: ''
});

export const NewGrupoLineaInvestigacionDTO = (idgrupo: number): GrupoLineaInvestigacionDTO => ({
  iddecinvgrupolineainvestigacion: 0,
  iddecinvgrupoinvestigacion: idgrupo,
  iddecinvareaconocimiento: 0,
  iddecinvlineasinvestigacion: 0,
  nombreArea: '',
  nombreLinea: ''
});

export const voidGrupoReasignacionDTO = (): GrupoReasignacionDTO => ({
  Iddecinvgrupoinvestigacion: 0,
  IdNuevoEncargado: 0,
  Observacion: ''
});

export const voidGrupoCambioEstadoDTO = (): GrupoCambioEstadoDTO => ({
  Iddecinvgrupoinvestigacion: 0,
  IdPersona: 0,
  Tipo: '',
  IdPersonaMiembro: 0,
  Estado: 'A',
  Observacion: ''
})

export const voidGrupoInvestigacionEventoDTO = (): GrupoInvestigacionEventoDTO => ({
  iddecinvgrupoinvestigacionevento: 0,
  iddecinvgrupoinvestigacion: 0,
  idpersona: 0,
  observacion: '',
  tipo: '',
  estado: '',
  activo: '',
  fecharegistro: new Date,
})

export const VoidPersonaGrupo = (): PersonaGrupo => ({
  idpersona: 0,
  numeroidentificacion: '',
  nombrecompleto: '',
  email: '',
  scopusId: '',
})